import * as React from 'react';
export const CorePopoverContext = /*#__PURE__*/ React.createContext({
    excludeClickOutsideClasses: []
});

//# sourceMappingURL=CorePopoverContext.js.map